import { render, staticRenderFns } from "./repCreateClientModal.vue?vue&type=template&id=68c3b49a&scoped=true"
import script from "./repCreateClientModal.vue?vue&type=script&lang=js"
export * from "./repCreateClientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c3b49a",
  null
  
)

export default component.exports